import { FileUploadingService } from '../../@util/file-uploading-progress/file-uploading.service';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { MEDICAL_RECORDS_CONFIG } from "../@config/api";
import * as i0 from "@angular/core";
import * as i1 from "../../@util/file-uploading-progress/file-uploading.service";
import * as i2 from "@angular/common/http";
var MedicalRecordService = /** @class */ (function () {
    function MedicalRecordService(fileUploadin, http) {
        this.fileUploadin = fileUploadin;
        this.http = http;
        this.config = MEDICAL_RECORDS_CONFIG;
    }
    // pushFileToStorage(data: { file: File, fileInfo: { title: string, category: string, description: string, sslgId: string } }) {
    //   this.fileUploadin.uploadFile('/api/claimant/medical-record', data);
    // }
    // uploadEnded(): Observable<any> {
    //   return this.fileUploadin.uploadEnded;
    // }
    //
    // getDocuments(sslgId: any, title: string) {
    //   return this.fileUploadin.getDocuments('/api/claimant/medical-record/' + sslgId, title);
    // }
    //
    // isExist(sslgId: string, name: string) {
    //   return this.fileUploadin.isExist('/api/claimant/medical-record/' + sslgId + '/exist/' + name);
    // }
    //
    //
    // getTitlesForClaim(sslgId: string) {
    //   return this.fileUploadin.getTitlesForClaim('/api/claimant/medical-record/' + sslgId + '/titles');
    // }
    MedicalRecordService.prototype.getVisitsInformation = function (sslgId, catalogItemId) {
        return this.http.get(this.config.getVisitsInformation(sslgId, catalogItemId));
    };
    MedicalRecordService.prototype.getRequestsByType = function (sslgId, requestType) {
        if (requestType === 'SSA') {
            return null;
        }
        if (requestType !== 'ALL') {
            return this.http.get(this.config.getRequestsByTypeOne(sslgId, requestType));
        }
        else {
            return this.http.get(this.config.getRequestsByTypeAll(sslgId));
        }
    };
    MedicalRecordService.prototype.createRequest = function (sslgId, $event) {
        return this.http.post(this.config.createRequest(sslgId), $event);
    };
    MedicalRecordService.prototype.downloadDocument = function (sslgId, documentId) {
        return this.fileUploadin.downloadDocument(this.config.downloadDocument(sslgId, documentId));
    };
    MedicalRecordService.prototype.getRequestById = function (sslgId, requestId) {
        return this.http.get(this.config.getRequestById(sslgId, requestId));
    };
    MedicalRecordService.prototype.getUploadedDocument = function (sslgId, documentId) {
        return this.http.get(this.config.getUploadedDocument(sslgId, documentId));
    };
    MedicalRecordService.prototype.sendFile = function (sslgId, requestId, file) {
        var formData = new FormData();
        if (file === undefined || file === null) {
            return;
        }
        formData.append('file', file.file);
        formData.append('fileName', file.file.name);
        formData.append('type', file.type);
        formData.append('uploadedBy', file.uploadedBy);
        return this.http.post(this.config.sendDocument(sslgId, requestId), formData);
    };
    MedicalRecordService.prototype.uploadFile = function (sslgId, requestId, file) {
        var formData = new FormData();
        if (file === undefined || file === null) {
            return;
        }
        formData.append('file', file.file);
        formData.append('type', file.type);
        formData.append('uploadedBy', file.uploadedBy);
        var req = new HttpRequest('POST', this.config.uploadFile(sslgId, requestId), formData, {
            reportProgress: true,
            responseType: 'text'
        });
        this.fileUploadin.show(0, file.file.name);
        return this.http.request(req);
    };
    MedicalRecordService.prototype.getDocTypes = function (sslgId) {
        return this.http.get(this.config.getDocTypes(sslgId));
    };
    MedicalRecordService.prototype.getDocumentById = function (sslgId, docId) {
        return this.http.get(this.config.getDocumentById(sslgId, docId));
    };
    MedicalRecordService.prototype.deleteDocument = function (sslgId, docId) {
        return this.http.post(this.config.deleteDocument(sslgId, docId), {});
    };
    MedicalRecordService.prototype.updateDocument = function (sslgId, docId, value) {
        return this.http.post(this.config.updateDocument(sslgId, docId), value);
    };
    MedicalRecordService.prototype.changeDocumentStatus = function (sslgId, id, status) {
        return this.http.post(this.config.changeDocumentStatus(sslgId, id), status);
    };
    MedicalRecordService.prototype.getSSADocument = function (sslgId) {
        return this.http.get(this.config.getSSADocument(sslgId));
    };
    MedicalRecordService.prototype.changeSSADocumentStatus = function (sslgId, id, status) {
        return this.http.post(this.config.changeSSADocumentStatus(sslgId, id), status);
    };
    MedicalRecordService.prototype.getDocSSATypes = function (sslgId) {
        return this.http.get(this.config.getDocSSATypes(sslgId));
    };
    MedicalRecordService.prototype.downloadSSADocument = function (sslgId, id) {
        return this.fileUploadin.downloadDocument(this.config.downloadSSADocument(sslgId, id));
    };
    MedicalRecordService.prototype.uploadSSAFile = function (sslgId, file) {
        var formData = new FormData();
        if (file === undefined || file === null) {
            return;
        }
        formData.append('file', file.file);
        formData.append('type', file.type);
        formData.append('uploadedBy', file.uploadedBy);
        var req = new HttpRequest('POST', this.config.uploadSSAFile(sslgId), formData, {
            reportProgress: true,
            responseType: 'text'
        });
        this.fileUploadin.show(0, file.file.name);
        return this.http.request(req);
    };
    MedicalRecordService.prototype.updateDocumentSsa = function (sslgId, docId, value) {
        return this.http.post(this.config.updateDocumentSsa(sslgId, docId), value);
    };
    MedicalRecordService.prototype.getDocumentSsaById = function (sslgId, docId) {
        return this.http.get(this.config.getDocumentSsaById(sslgId, docId));
    };
    MedicalRecordService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MedicalRecordService_Factory() { return new MedicalRecordService(i0.ɵɵinject(i1.FileUploadingService), i0.ɵɵinject(i2.HttpClient)); }, token: MedicalRecordService, providedIn: "root" });
    return MedicalRecordService;
}());
export { MedicalRecordService };
